if (!customElements.get('ax-reassurance-slider')) {
  customElements.define('ax-reassurance-slider', class AxReassuranceSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const slider = this.querySelector('.swiper');
      if (!slider) return;

      const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }

        this.swiper = new Swiper(slider, {
          slidesPerView: 1,
          loop: true,
          pagination: {
            el: this.querySelector('.ax-reassurance__pagination'),
            clickable: true,
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        });
      };

      initSwiper();
    }
  });
}
